import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExternalsModule } from '@externals/externals.module';
import { SharedModule } from '@shared/shared.module';
import { ConfigurationModule } from './configuration/configuration.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ConfigurationModule,
    ExternalsModule,
    SharedModule,
  ],
  providers: [Title],
  bootstrap: [AppComponent],
  schemas: [],
})
export class AppModule {}
